/**
 * moneyUsering模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const moneyUsering = {
  // 扣减费用（次数）
  addMoneyUsering (params) {
    return axios.post('/api/moneyUsering/addMoneyUsering', params)
  },
  // 获取用户剩余费用信息
  getUserMoneyBalanceInfo () {
    return axios.get('/api/moneyUsering/getUserMoneyBalanceInfo')
  },
  // 购买纪录
  getGetMoneyOrders (params) {
    return axios.get('/api/moneyUsering/GetGetMoneyOrders', { params })
  },
  // 使用纪录
  getMoneyUseringList (params) {
    return axios.get('/api/moneyUsering/GetMoneyUseringList', { params })
  },
  // 判断用户余额表是否存在当前公司，如果没有初始化信息
  initializeMoney () {
    return axios.post('/api/moneyUsering/InitializeMoney')
  },
  // 获取出售产品信息
  getProductList () {
    return axios.get('/api/moneyUsering/GetProductList')
  },
  // 调用支付宝充值
  alipayPayment (params) {
    return axios.post('/api/moneyUsering/AlipayPayment', params)
  },
  // 管理员充值
  adminRecharge (params) {
    return axios.post('/api/moneyUsering/AdminRecharge', params)
  }
}

export default moneyUsering
